/** True when Supabase PostgREST has not applied user_settings jsonb columns yet. */
export function isUserSettingsSchemaMismatch(error: unknown): boolean {
  const msg =
    error && typeof error === 'object' && 'message' in error
      ? String((error as { message: unknown }).message)
      : String(error ?? '');
  const lower = msg.toLowerCase();
  return (
    lower.includes('schema cache') ||
    lower.includes("could not find the") ||
    lower.includes('column') && (lower.includes('dashboard_prefs') || lower.includes('notification_prefs'))
  );
}
